import { PASTAS_CONFIG, type DocItem } from './types.js'

type Props = {
  documentos: DocItem[]
  catFiltro: string
  onCatFiltroChange: (cat: string) => void
}

export function DocumentosFolders({ documentos, catFiltro, onCatFiltroChange }: Props) {
  if (documentos.length === 0) return null

  return (
    <section className='cf3-block' aria-label='Filtrar por categoria'>
      <div className='cf3-doc-folders'>
        {PASTAS_CONFIG.map((p) => {
          const count = documentos.filter((d) => d.categoria === p.cat).length
          const isActive = catFiltro === p.cat
          return (
            <button
              key={p.cat}
              className={`cf3-doc-folder cf3-doc-folder--inline${isActive ? ' cf3-doc-folder--active' : ''}`}
              onClick={() => onCatFiltroChange(isActive ? '' : p.cat)}
              aria-pressed={isActive}
              aria-label={`${p.cat} · ${count} documento${count !== 1 ? 's' : ''}`}
            >
              <span className='cf3-doc-folder__nome'>{p.cat}</span>
              <span className='cf3-doc-folder__count'>{count}</span>
            </button>
          )
        })}
      </div>
    </section>
  )
}
